import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CALENDAR_HEART: GlameraIconDefinition = {
  name: 'calendar-heart',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-calendar-heart-hanger glm-calendar-heart-hanger-left" pathLength="1" d="M8 2v4"></path>
    <path class="glm-calendar-heart-hanger glm-calendar-heart-hanger-right" pathLength="1" d="M16 2v4"></path>
    <rect class="glm-calendar-heart-body" pathLength="1" width="18" height="18" x="3" y="4" rx="2"></rect>
    <path class="glm-calendar-heart-header" d="M3 10h18"></path>
    <path class="glm-calendar-heart-mark" d="M14.62 17.8A2.25 2.25 0 1118 14.836a2.25 2.25 0 113.38 2.966l-2.626 2.856a.998.998 0 01-1.507 0z"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-calendar-heart-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './calendar-heart.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CalendarHeartIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CALENDAR_HEART;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
